import type SharedStore from './schema/SharedStore';
import { createStore } from 'owa-satcheljs';
import { type UserActionType } from './schema/UserAction';
import type RequestState from './schema/RequestState';

const initialSharedStore: SharedStore = {
    userAction: {
        userActionType: 0,
        userActionState: 0,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (13,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        userActionButtonId: null,
    },
};

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createStore (IIFE) called at module scope is not allowed. This may cause unwanted side effects. */
const store = createStore<SharedStore>('bookwithme-shared', initialSharedStore)();
export default store;
export const getStore = () => store;
